MoyaComponents.register('toy.vakinn', [
	'/static/local/toy/images/vakinn/images.css?v2.css',
]);
